import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '../views/Home.vue';
import Login from '../views/Login.vue';
import pub from './../../common/public';
import SelectRole from '../views/SelectRole.vue';
import store from '../store/index';
import axios from 'axios';
Vue.use(VueRouter);
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}

let change_password = () => import('../views/personal_center/change_password/index.vue')
let propertyIndex = () => import('../views/property/index.vue')
let personal_center = () => import('../views/personal_center/index.vue')
let home_page = () => import('../views/home_page/index.vue')
let terms = () => import('../views/terms/index.vue')
let charges = () => import('../views/charges/index.vue')
let payment = () => import('../views/coin/payment.vue')
let feature = () => import('../views/help_center/features')
let order = () => import('../views/order/index.vue')
let department = () => import('../views/department/index.vue')
let addDepartment = () => import('../views/department/addDepartment.vue')
let staffing = () => import('../views/staffing/index.vue')
let staffCreate = () => import('../views/staffing/create.vue')
let staffEdit = () => import('../views/staffing/edit.vue')
let transfer = () => import('../views/staffing/transfer.vue')
let message = () => import('../views/message/index.vue')
let temp = () => import('../views/template/index.vue')
let post = () => import('../views/property/post/index.vue')
let agent = () => import('../views/property/agent.vue')
let recommend = () => import('../views/property/recommend.vue')
let editJournal = () => import('../views/property/editJournal.vue')
let draftbox = () => import('../views/property/draftbox.vue')
let brosedata = () => import('../views/property/broseData.vue')
let zyCoupon = () => import('../views/property/zyCoupon.vue')
let agentProperty = () => import('../views/property/agentProperty.vue')
let journalProperty = () => import('../views/property/journalProperty.vue')
let propertyMessage = () => import('../views/property/messages.vue')
let role = () => import('../views/role/index.vue')
let addOrEdit = () => import('../views/role/add_or_edit')
let company = () => import('../views/company/index.vue')
let propertyTerms = () => import('../views/terms/index.vue')
let propertyCharges = () => import('../views/charges/index.vue')
let journal = () => import('../views/journal/index.vue')
let dealData = () => import('../views/deal_data/index.vue')
let subdeal = () => import('../views/deal_data/subdeal.vue')
let coin = () => import('../views/coin/index.vue')
let coinRecord = () => import('../views/coin/record.vue')
let coinCoupon = () => import('../views/coin/coupon.vue')
let coinPayment = () => import('../views/coin/payment.vue')

let helpIndex = () => import('../views/coin/helpreset/helpIndex.vue')
let mainBody = () => import('../views/coin/helpreset/mainBody.vue')
let asidelist = () => import('../views/coin/helpreset/asidelist.vue')
let searchresult = () => import('../views/coin/helpreset/searchresult.vue')

let recorDetail = () => import('../views/coin/record/detail.vue')
let orderPay = () => import('../views/coin/orderPay.vue')
// let paytran = () => import('../views/coin/paytran.vue')
let orderDetail = () => import('../views/coin/orderDetail.vue')
let appDown = () => import('../views/app_download/index')
let QRCodeDownload = () => import('../views/app_download/QRCodeDownload')
let orgManage = () => import('../views/org_manage/index.vue')
let orgCreate = () => import('../views/org_manage/create.vue')
let orgUpdate = () => import('../views/org_manage/update.vue')

const routes = [{
  path: '/',
  component: Home,
  name: pub.routeNameLists.HomeBase,
  children: [{
    path: '/changepassword',
    name: pub.routeNameLists.ChangePassword,
    component: change_password,
    meta: {
      title: '修改密码',
      showTab: true,
      activeMainMenu: pub.routeNameLists.Personal,
      activeSubMenu: pub.routeNameLists.PersonalCenter
    }
  },
  {
    path: '/personalcenter',
    name: pub.routeNameLists.PersonalCenter,
    component: personal_center,
    meta: {
      title: '个人中心',
      showTab: true,
      activeMainMenu: pub.routeNameLists.Personal,
      activeSubMenu: pub.routeNameLists.PersonalCenter
    }
  },
  {
    path: '/homepage',
    name: pub.routeNameLists.HomePage,
    component: home_page,
    meta: {
      title: '首页_首页',
      showTab: true,
      activeMainMenu: pub.routeNameLists.Home,
      activeSubMenu: pub.routeNameLists.HomePage
    }
  },
  {
    path: '/helpcenter/terms',
    name: pub.routeNameLists.HelpTerms,
    component: terms,
    meta: {
      title: '帮助中心_放盘条款',
      showTab: false,
      activeMainMenu: pub.routeNameLists.HelpCenter,
      activeSubMenu: pub.routeNameLists.HelpTerms
    }
  },
  {
    path: '/helpcenter/charges',
    name: pub.routeNameLists.HelpCharges,
    component: charges,
    meta: {
      title: '帮助中心_收费标准',
      showTab: false,
      activeMainMenu: pub.routeNameLists.HelpCenter,
      activeSubMenu: pub.routeNameLists.HelpCharges
    }
  },
  {
    path: '/helpcenter/payment',
    name: pub.routeNameLists.HelpCoinPayment,
    component: payment,
    meta: {
      title: '帮助中心_付款方式',
      showTab: true,
      activeMainMenu: pub.routeNameLists.HelpCenter,
      activeSubMenu: pub.routeNameLists.HelpCoinPayment
    }
  },
  {
    path: '/helpcenter/feature',
    name: pub.routeNameLists.HelpFeature,
    component: feature,
    meta: {
      title: '帮助中心_功能介绍',
      showTab: true,
      //activeMainMenu: pub.routeNameLists.HelpCenter,
      activeSubMenu: pub.routeNameLists.HelpFeature
    }
  },
  {
    path: '/order/index',
    name: pub.routeNameLists.Order,
    component: order,
    meta: {
      title: '订单管理_订单管理',
      showTab: true,
      activeMainMenu: pub.routeNameLists.Indent,
      activeSubMenu: pub.routeNameLists.Order
    }
  },
  {
    path: '/department/index',
    name: pub.routeNameLists.DepartmentManage,
    component: department,
    meta: {
      title: '业务设置_分行管理',
      showTab: true,
      activeMainMenu: pub.routeNameLists.System,
      activeSubMenu: pub.routeNameLists.DepartmentManage
    }
  },
  {
    path: '/department/departmentadd',
    name: pub.routeNameLists.AddDepartment,
    component: addDepartment,
    meta: {
      title: '业务设置_分行管理_新增分行',
      showTab: true,
      activeMainMenu: pub.routeNameLists.System,
      activeSubMenu: pub.routeNameLists.DepartmentManage
    }
  },
  {
    path: '/staffing/index',
    name: pub.routeNameLists.StaffingIndex,
    component: staffing,
    meta: {
      title: '业务设置_员工管理',
      showTab: true,
      activeMainMenu: pub.routeNameLists.System,
      activeSubMenu: pub.routeNameLists.StaffingIndex
    }
  },
  {
    path: '/staffing/create',
    name: pub.routeNameLists.StaffingCreate,
    component: staffCreate,
    meta: {
      title: '业务设置_员工管理_新增员工',
      showTab: true,
      activeMainMenu: pub.routeNameLists.System,
      activeSubMenu: pub.routeNameLists.StaffingIndex
    }
  },
  {
    path: '/staffing/edit',
    name: pub.routeNameLists.StaffingEdit,
    component: staffEdit,
    meta: {
      title: '业务设置_员工管理_编辑员工',
      showTab: true,
      activeMainMenu: pub.routeNameLists.System,
      activeSubMenu: pub.routeNameLists.StaffingIndex
    }
  },
  {
    path: '/staffing/transfer',
    name: pub.routeNameLists.StaffingTransfer,
    component: transfer,
    meta: {
      title: '业务设置_员工管理_转移(员工楼盘转移或员工组织转移)',
      showTab: true,
      activeMainMenu: pub.routeNameLists.System,
      activeSubMenu: pub.routeNameLists.StaffingIndex
    }
  },

  {
    path: '/cmessage/index',
    name: pub.routeNameLists.MessageManage,
    component: message,
    meta: {
      title: '消息中心',
      showTab: true,
      activeMainMenu: pub.routeNameLists.Message,
      activeSubMenu: pub.routeNameLists.MessageManage
    }
  },

  {
    path: '/template',
    name: pub.routeNameLists.BaseTemplate,
    component: temp,
    meta: {
      title: '开发用基本模板',
      showTab: false
    }
  },

  {
    path: '/property/post',
    name: pub.routeNameLists.Post,
    component: post,
    meta: {
      title: '楼盘管理_楼盘管理_刊登楼盘',
      showTab: true,
      activeMainMenu: pub.routeNameLists.Property,
      activeSubMenu: pub.routeNameLists.PropertyIndex
    }
  },
  {
    path: '/property/agent',
    name: pub.routeNameLists.Agent,
    component: agent,
    meta: {
      title: '楼盘管理_楼盘代理人',
      showTab: true,
      activeMainMenu: pub.routeNameLists.Property,
      activeSubMenu: pub.routeNameLists.Agent
    }
  },
  {
    path: '/property/recommend',
    name: pub.routeNameLists.Recommend,
    component: recommend,
    meta: {
      title: '樓盤管理_重新推前次數記錄',
      showTab: true,
      activeMainMenu: pub.routeNameLists.Property,
      activeSubMenu: pub.routeNameLists.Recommend
    }
  },
  {
    path: '/property/editJournal',
    name: pub.routeNameLists.EditJournal,
    component: editJournal,
    meta: {
      title: '樓盤管理_樓盤修改概要',
      showTab: true,
      activeMainMenu: pub.routeNameLists.Property,
      activeSubMenu: pub.routeNameLists.EditJournal
    }
  },
  {
    path: '/property/brosedata',
    name: pub.routeNameLists.BroseDaTa,
    component: brosedata,
    meta: {
      title: '楼盘管理_楼盘管理_浏览数据',
      showTab: true,
      activeMainMenu: pub.routeNameLists.Property,
      activeSubMenu: pub.routeNameLists.PropertyIndex
    }
  },
  {
    path: '/property/zyCoupon',
    name: pub.routeNameLists.ZyCoupon,
    component: zyCoupon,
    meta: {
      title: '楼盘管理_楼盘管理_中原优惠券',
      showTab: true,
      activeMainMenu: pub.routeNameLists.Property,
      activeSubMenu: pub.routeNameLists.PropertyIndex
    }
  },
  {
    path: '/property/subdeal',
    name: pub.routeNameLists.SubDeal,
    component: subdeal,
    meta: {
      title: '楼盘管理_楼盘管理_添加成交',
      showTab: true,
      activeMainMenu: pub.routeNameLists.System,
      activeSubMenu: pub.routeNameLists.Deal
    }
  },

  {
    path: '/property/draftbox',
    name: pub.routeNameLists.DraftBox,
    component: draftbox,
    meta: {
      title: '楼盘管理_楼盘管理_草稿箱',
      showTab: true,
      activeMainMenu: pub.routeNameLists.Property,
      activeSubMenu: pub.routeNameLists.PropertyIndex
    }
  },
  {
    path: '/property/agentProperty',
    name: pub.routeNameLists.AgentProperty,
    component: agentProperty,
    meta: {
      title: '楼盘管理_楼盘代理人_代理楼盘列表',
      showTab: true,
      activeMainMenu: pub.routeNameLists.Property,
      activeSubMenu: pub.routeNameLists.Agent
    }
  },
  {
    path: '/property/journalProperty',
    name: pub.routeNameLists.JournalProperty,
    component: journalProperty,
    meta: {
      title: '楼盘管理_樓盤修改概要_楼盘详细记录',
      showTab: true,
      activeMainMenu: pub.routeNameLists.Property,
      activeSubMenu: pub.routeNameLists.EditJournal
    }
  },
  //   {
  //   path: '/property/index',
  //   name: pub.routeNameLists.Property,
  //   component: () => import(/*  */  '../views/property/index.vue'),
  //   meta: {
  //     title: "樓盤管理",
  //     showTab: true,
  //   }
  // },
  {
    path: '/property/index',
    name: pub.routeNameLists.PropertyIndex,
    component: propertyIndex,
    meta: {
      title: '楼盘管理_楼盘管理',
      showTab: true,
      activeMainMenu: pub.routeNameLists.Property,
      activeSubMenu: pub.routeNameLists.PropertyIndex
    }
  },
  {
    path: '/property/messages',
    name: pub.routeNameLists.Messages,
    component: propertyMessage,
    meta: {
      title: '楼盘管理_留言管理',
      showTab: true,
      activeMainMenu: pub.routeNameLists.Property,
      activeSubMenu: pub.routeNameLists.Messages
    }
  },
  //   {
  //   path: '/property/company',
  //   name: pub.routeNameLists.System,
  //   component: () => import(/*  */  '../views/company/index.vue'),
  //   meta: {
  //     title: '业务设置',
  //     showTab: true
  //   }
  // },
  {
    path: '/property/role',
    name: pub.routeNameLists.RolePermission,
    component: role,
    meta: {
      title: '业务设置_角色/權限管理',
      showTab: true
    }
  },
  {
    path: '/property/role/operator',
    name: pub.routeNameLists.AddOrEditRole,
    component: addOrEdit,
    meta: {
      title: '业务设置_角色/权限管理_添加角色',
      showTab: true
    }
  },
  {
    path: '/property/company',
    name: pub.routeNameLists.Company,
    component: company,
    meta: {
      title: '业务设置_公司资料',
      showTab: true,
      activeMainMenu: pub.routeNameLists.System,
      activeSubMenu: pub.routeNameLists.Company
    }
  },
  {
    path: '/property/terms',
    name: pub.routeNameLists.Terms,
    component: propertyTerms,
    meta: {
      title: '楼盘管理_放盘条款',
      showTab: true,
      activeMainMenu: pub.routeNameLists.HelpCenter,
      activeSubMenu: pub.routeNameLists.Terms
    }
  },
  {
    path: '/property/charges',
    name: pub.routeNameLists.Charges,
    component: propertyCharges,
    meta: {
      title: '楼盘管理_收费标准',
      showTab: true,
      activeMainMenu: pub.routeNameLists.HelpCenter,
      activeSubMenu: pub.routeNameLists.Charges
    }
  },
  {
    path: '/property/journal',
    name: pub.routeNameLists.Journal,
    component: journal,
    meta: {
      title: '业务设置_操作日志',
      showTab: true,
      activeMainMenu: pub.routeNameLists.System,
      activeSubMenu: pub.routeNameLists.Journal
    }
  },
  {
    path: '/property/dealData',
    name: pub.routeNameLists.Deal,
    component: dealData,
    meta: {
      title: '业务设置_成交数据',
      showTab: true,
      activeMainMenu: pub.routeNameLists.System,
      activeSubMenu: pub.routeNameLists.Deal
    }
  },
  //   /* {
  //   path: "/coin/index",
  //   name: pub.routeNameLists.Coin,
  //   component: () => import(/*  */  '../views/coin/index.vue'),
  //   meta: {
  //     title: "金幣管理",
  //     showTab: true
  //   }
  // },*/
  {
    path: '/coin/index',
    name: pub.routeNameLists.CoinIndex,
    component: coin,
    meta: {
      title: '金币管理_金币管理',
      showTab: true,
      activeMainMenu: pub.routeNameLists.Coin,
      activeSubMenu: pub.routeNameLists.CoinIndex
    }
    //   //redirect: "/coin/manage/organization",
    //   /* children: [{
    //   path: "/coin/manage/organization",
    //   name: pub.routeNameLists.ManageOrganization,
    //   component: () => import(/*  */  "../views/coin/manage/organization.vue")
    // },
    // {
    //   path: '/coin/manage/personal',
    //   name: pub.routeNameLists.ManagePersonal,
    //   component: () => import(/*  */  '../views/coin/manage/personal.vue')
    // }
    // ] */
  },
  {
    path: '/coin/record',
    name: pub.routeNameLists.CoinRecord,
    // redirect: "/coin/record/organization",
    component: coinRecord,
    meta: {
      title: '金币管理_金币记录',
      showTab: true,
      activeMainMenu: pub.routeNameLists.Coin,
      activeSubMenu: pub.routeNameLists.CoinRecord
    }
    //   /* children: [{
    //    path: "/coin/record/organization",
    //    name: pub.routeNameLists.RecordOrganization,
    //    component: () => import(/*  */  "../views/coin/record/organization.vue")
    //  },
    //  {
    //    path: '/coin/record/personal',
    //    name: pub.routeNameLists.RecordPersonal,
    //    component: () => import(/*  */  '../views/coin/record/personal.vue')
    //  }
    //  ]*/
  },
  {
    path: '/coin/coupon',
    name: pub.routeNameLists.CoinCoupon,
    component: coinCoupon,
    meta: {
      title: '金币管理_优惠券',
      showTab: true,
      activeMainMenu: pub.routeNameLists.Coin,
      activeSubMenu: pub.routeNameLists.CoinCoupon
    }
  },
  {
    path: '/helpcenter/helpIndex',
    name: pub.routeNameLists.HelpIndex,
    component: helpIndex,
    meta: {
      title: '帮助中心_首页',
      showTab: true,
      activeMainMenu: pub.routeNameLists.HelpCenter,
    }
  },
  {
    path: '/helpcenter/mainbody',
    name: pub.routeNameLists.MainBody,
    component: mainBody,
    meta: {
      title: '帮助中心_正文',
      showTab: true,
      activeMainMenu: pub.routeNameLists.HelpCenter,
    }
  },
  {
    path: '/helpcenter/asidelist',
    name: pub.routeNameLists.HelpCateList,
    component: asidelist,
    meta: {
      title: '帮助中心_列表',
      showTab: true,
      activeMainMenu: pub.routeNameLists.HelpCenter,
    }
  },
  {
    path: '/helpcenter/searchresult',
    name: pub.routeNameLists.HelpSearchResult,
    component: searchresult,
    meta: {
      title: '帮助中心_搜索结果',
      showTab: true,
      activeMainMenu: pub.routeNameLists.HelpCenter,
    }
  },



  {
    path: '/coin/payment',
    name: pub.routeNameLists.CoinPayment,
    component: coinPayment,
    meta: {
      title: '金币管理_付款方式',
      showTab: true,
      activeMainMenu: pub.routeNameLists.HelpCenter,
      activeSubMenu: pub.routeNameLists.CoinPayment
    }
  },
  {
    path: '/coin/record/detail',
    name: pub.routeNameLists.RecordDetail,
    component: recorDetail,
    meta: {
      title: '金币管理_金币记录_单条金币记录详情',
      showTab: true,
      activeMainMenu: pub.routeNameLists.Coin,
      activeSubMenu: pub.routeNameLists.CoinRecord
    }
  },
  // {
  //   path: '/coin/paytran',
  //   name: pub.routeNameLists.PayTran,
  //   component: paytran,
  //   meta: {
  //     title: '订单管理_订单管理_立即支付',
  //     showTab: false,
  //   }
  // },
  {
    path: '/coin/order-pay',
    name: pub.routeNameLists.OrderPay,
    component: orderPay,
    meta: {
      title: '订单管理_订单管理_立即支付',
      showTab: true,
      activeMainMenu: pub.routeNameLists.Indent,
      activeSubMenu: pub.routeNameLists.Order
    }
  },
  {
    path: '/coin/order-detail',
    name: pub.routeNameLists.OrderDetail,
    component: orderDetail,
    meta: {
      title: '金币管理_金币管理_购买金币',
      showTab: true,
      activeMainMenu: pub.routeNameLists.Coin,
      activeSubMenu: pub.routeNameLists.CoinIndex
    }
  },
  {
    path: '/appdownload',
    name: pub.routeNameLists.AppDownload,
    component: appDown,
    meta: {
      title: 'app下载',
      showTab: false
    }
  },
  {
    path: '/appdownload/qrcodedownload',
    name: pub.routeNameLists.QRCodeDownload,
    component: QRCodeDownload,
    meta: {
      title: '二维码下载',
      showTab: false
    }
  },
  //   /* {
  //   path: "/coin/record",
  //   name: pub.routeNameLists.CoinRecord,
  //   redirect: "/coin/record/organization",
  //   component: () => import(/*  */  "../views/coin/record.vue"),
  //   children: [{
  //     path: "/coin/record/organization",
  //     name: pub.routeNameLists.RecordOrganization,
  //     component: () => import(/*  */  "../views/coin/record/organization.vue")
  //   },
  //   {
  //     path: '/coin/record/personal',
  //     name: pub.routeNameLists.RecordPersonal,
  //     component: () => import(/*  */  '../views/coin/record/personal.vue')
  //   }
  //   ]
  // }, */
  {
    path: '/org-manage/index',
    name: pub.routeNameLists.SystemOrg,
    component: orgManage,
    meta: {
      title: '业务设置_组织管理',
      showTab: true,
      activeMainMenu: pub.routeNameLists.System,
      activeSubMenu: pub.routeNameLists.SystemOrg
    }
  },
  {
    path: '/org-manage/create',
    // name: pub.routeNameLists.OrderDetail,
    component: orgCreate,
    meta: {
      title: '业务设置_组织管理_新增组织',
      showTab: true,
      activeMainMenu: pub.routeNameLists.System,
      activeSubMenu: pub.routeNameLists.SystemOrg
    }
  },
  {
    path: '/org-manage/edit/:id',
    // name: pub.routeNameLists.OrderDetail,
    component: orgUpdate,
    meta: {
      title: '业务设置_组织管理_修改组织',
      showTab: true,
      activeMainMenu: pub.routeNameLists.System,
      activeSubMenu: pub.routeNameLists.SystemOrg
    }
  }
  ]
},

{
  path: '/login',
  name: pub.routeNameLists.Login,
  component: Login
},
{
  path: '/select-role',
  name: pub.routeNameLists.SelectRole,
  component: SelectRole,
  meta: {
    showTab: false
  }
},
/** 匹配到配置以为的路由重定向到主页面*/
{ path: '*', redirect: '/' },
// 首页改版发现定向问题
// { path: '*', redirect: '/homepage' },
// {
//   path: '*',  //*号表示匹配任意内容
//   redirect: '/homepage',
//   name: pub.routeNameLists.HomePage,
//     component: home_page,
//     meta: {
//       title: '首页_首页',
//       showTab: true,
//       activeMainMenu: pub.routeNameLists.Home,
//       activeSubMenu: pub.routeNameLists.HomePage
//     }
// }

  // {
  //   path: '/about',
  //   name: 'about',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/*  */  /* webpackChunkName: "about" */ '../views/About.vue')
  // }
];

const router = new VueRouter({
  mode: 'history',
  base: '/',
  routes
});

/**登录检测*/
router.beforeEach((to, from, next) => {
  if (to.name == 'post' && to.query.email && to.query.signature) {
    next();
    return;
  }
  if (to.path.includes('/qrCodeDownload') || to.path.includes('/appdownload')) {
    next();
    return;
  }
  //  if(!pub.getCookie('dEVaUDFrZ1kd0RA') && to.path.includes('/coin/paytran')){
  //   // router.push(`/coin/paytran`);
  //   next();
  //   return;
  // }else 
  if (!pub.getCookie('dEVaUDFrZ1kd0RA') && !to.path.includes('/login')) {
    if ((from.path === '/login' && to.path === '/select-role') || to.name == 'post') {
      next();
    } else {
      router.push(`/login`);
    }
  } else {
    if(pub.getCookie('dEVaUDFrZ1kd0RA')){
      if(to.path === '/login'){
        router.push('/homepage');
      }else{
      pub.getcompanyCategorys().then((res)=>{
       /** 1:中原工住宅  2:中原工商 0:正常显示 */ 
       if(res == 2){
         let routesDis = ['/staffing','/org-manage','/department','/helpcenter','/property/company','/property/dealData','/property/subdeal','/property/journal']
         let disRoutes = routesDis.some(substring => to.path.includes(substring));
         if(disRoutes){
           router.push('/homepage');
         }else{
           next()
         }
       }else if(res == 1){
         let routesDis = ['/property/post','/property/draftbox','/property/terms','/property/charges','/property/brosedata','/property/agent','/coin','/order','/staffing','/org-manage','/department','/helpcenter','/property/company','/property/dealData','/property/subdeal','/property/journal']
         let disRoutes = routesDis.some(substring => to.path.includes(substring));
         if(disRoutes){
           router.push('/homepage');
         }else{
           next()
         }
       }else{
         next();
       }
     })
    }

    }else{
      next();
    }
    // next();
  }
});


router.afterEach(to => {
  typeof gtag != 'undefined' ?
    gtag('config', 'UA-139040958-7', {
      page_path: to.fullPath
    }) :
    '';
});
/*
async function doSomething(next){
  await obtainUserInfo();
  await obtainPermissionRoutes()
  next()
}
async function obtainUserInfo() {
  //if ( !store.getters.userInfo ) {
  let res = await axios.get(pub.getApi().GetUserInfo)
  store.commit('setUserInfo', res.data.result)
  //}
}
async function obtainPermissionRoutes() {
  //if ( !store.getters.routes ){
  let res = await axios.get(pub.getApi().GetMenuPerByRoleID, {
    roleId: store.getters.userInfo.currentRoleId
  })
  store.commit('setRoutes', res.data.result)
  //}
}*/
export default router;
